module.exports = __webpack_public_path__ + "img/bg3.7e2f948d.jpg";